export default __webpack_public_path__ + "static/media/facebook.c816e5f4.svg";